import IntegrationCallStepResourceModel from '../../generated/types/model/resource/IntegrationCallStepResourceModel';

export default class IntegrationCallStepResourceViewModel extends IntegrationCallStepResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
